import { useEffect, useState } from 'react';
import { fetchLocationData } from '../_api';
import AppWrappedStaticAutoComplete from '../../AppWrappedStaticAutoComplete';
import { LINK_FIELD_KEYS } from '../_const';

/**
 * Location input component for Epic/EpicCare Link stylized to work with Custom App Request Form
 * @param {Object} props properties
 * @returns Custom input
 */
const LocationField = props => {
	const [sOriginalOptions, setOriginalOptions] = useState([]);
	const [sLoading, setLoading] = useState(true);

	useEffect(() => {
		let active = true;

		async function fetchApi() {
			const results = await fetchLocationData();

			const processedResponse = results.map(location => ({
				value: location,
				label: location,
			}));

			setOriginalOptions(processedResponse);
			setLoading(false);
		}

		if (active) {
			fetchApi();
		}

		return () => {
			active = false;
		};
	}, []);

	return (
		<AppWrappedStaticAutoComplete
			name={LINK_FIELD_KEYS.LOCATIONS}
			label={'Site Names'}
			sublabel='Type to search by location name.'
			originalOptions={sOriginalOptions}
			multiple
			isLoading={sLoading}
			helperText={'Select one or more sites.'}
			{...props}
		/>
	);
};

export default LocationField;
